const COMPANY_LABELS = Object.freeze({
  PREVIDA: "Empresa A",
  "PREVIDA SEDE": "Empresa A - Sede",
  "CEMITERIO PREVIDA": "Empresa B",
  "CEMITERIO PREVIDA SAO MIGUEL": "Empresa C",
  "MEMORIAL PARQUE MACEIO": "Empresa D",
  "PARQUE DAS FLORES": "Empresa E",
  "PARQUE DO AGRESTE": "Empresa F",
  "A FLOR DO CAFE": "Empresa G",
});

export function normalizeCompanyName(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
}

export function getCompanyDisplayName(value) {
  if (!value) return "";

  const normalized = normalizeCompanyName(value);
  if (normalized === "TODAS" || normalized === "TODOS") return value;

  return COMPANY_LABELS[normalized] || "Empresa";
}

export function toCompanyOption(value) {
  return {
    text: getCompanyDisplayName(value),
    value,
  };
}

export function toCompanyOptions(values) {
  return (values || []).map(toCompanyOption);
}
